import * as Yup from 'yup';

const hexColorRegexp = /^#([0-9a-fA-F]{6}|[0-9a-fA-F]{3})$/i;

export const hexColorValidationSchema = Yup.string()
  .required('Required')
  .matches(hexColorRegexp, 'Should be a hex string');

export const fontSizeValueSchema = Yup.number()
  .required('Required')
  .max(72, 'Should be less than 72')
  .min(10, 'Should be more than 10')
  .typeError('Required');

export const percentSchema = Yup.number()
  .min(0, 'Should be >= 0')
  .max(100, 'Should be <= 100')
  .typeError('Should be a number');

export const pageUrlSchema = Yup.string()
  .required('Required')
  .matches(/^\/.*/, 'Should be relative and starts with a "/"')
  .max(1000, 'Should be <= 1000 symbols');

export const widgetBreakDurationSchema = Yup.number()
  .integer('Should be integer')
  .required('Required')
  .min(0)
  .max(1000000)
  .typeError('Required');
